import React from "react";

interface InfoCardProps {
    title: string;
    items: Record<string, string | number>;
    className?: string;
    bgColor?: string;
    showSeparator?: boolean;
}

const InfoCard: React.FC<InfoCardProps> = ({ title, items, className, bgColor, showSeparator = false }) => (
    <div className={`flex flex-col gap-3 ${bgColor ? bgColor : "bg-darkcolor-800"} text-blue-200 px-2 py-1 rounded-lg border border-darkcolor-400 ${className ? className : "w-auto"}`}>
        <h3 className="font-semibold text-neutral-25">{title}</h3>
        <ul className={`text-sm tracking-wide gap-x-4 ${Object?.entries(items)?.length > 6 ? "grid grid-cols-2" : ""}`}>
            {Object?.entries(items)?.map(([key, value]) => (
                <li key={key} className={`flex justify-between items-center gap-6 ${showSeparator ? "border-b last:border-b-0 border-darkcolor-400 py-1 [&:nth-child(11)]:border-0" : ""}`}>
                    <span>{key}</span>
                    <span className="font-mono text-primary-400">{value}</span>
                </li>
            ))}
        </ul>
    </div>
);

export default InfoCard;
